const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/terms"],
    exact: true,
    component: "Terms",
  },
  {
    path: ["/", "/privacy"],
    exact: true,
    component: "Privacy",
  },
];

export default routes;
